export const profile = {
  name: 'Christine Eaton',
  title: 'Head of Global Sourcing Transformation',
  company: 'Morgan Stanley',
  location: 'Minneapolis, Minnesota, United States',
  phone: '+1 617 895 7529',
  email: 'christineeaton456@gmail.com',
  linkedin: 'linkedin.com/in/christine-eaton',
  linkedinUrl: 'https://www.linkedin.com/in/christine-eaton',
  portrait:
    'https://cdn.magicpatterns.com/uploads/dd45EH6daegxQoeLR4CMig/1516650661577-Picsart-AiImageEnhancer.jpg',
  headline: 'Transforming Source to Pay Through AI and Strategic Sourcing',
  subheadline:
    'Global transformation leader optimizing enterprise spend, strengthening controls, and driving digital first procurement at scale.',
}

export const trustMarks = [
  { label: 'Spend Managed', value: '$1B+' },
  { label: 'Years Experience', value: '25+' },
  { label: 'Enterprise', value: 'Morgan Stanley' },
  { label: 'Asset Management', value: 'Eaton Vance' },
  { label: 'Global CPG', value: 'General Mills' },
]

export const aboutParagraphs = [
  'Christine Eaton is a transformation leader who uses artificial intelligence to fundamentally change how procurement creates value. As Head of Global Sourcing Transformation at Morgan Stanley, she leads Source to Pay transformation across people, process, and technology for a global financial institution.',
  'Her career spans Morgan Stanley, Eaton Vance, Radisson Hotel Group, Ameriprise Financial Services, and General Mills. Across each organisation she has built scalable, digital first procurement operations, led enterprise vendor strategy, and partnered closely with Finance, Legal, Risk, and business leadership to optimise spend, strengthen controls, and improve execution speed.',
  'She brings a bias for action, deep category expertise, and a record of elevating the influence of procurement at executive committee level. Her focus today is AI enabled automation, acquisition integration, and private equity supply chain performance improvement that converts sourcing strategy into measurable margin.',
]

export const missionPillars = [
  {
    title: 'Digital First Operations',
    copy: 'End to end procurement platforms that give leadership spend visibility and an active opportunity pipeline.',
  },
  {
    title: 'AI Enabled Automation',
    copy: 'Applying AI and automation to sourcing execution, supplier governance, and Source to Pay workflow.',
  },
  {
    title: 'Acquisition Integration',
    copy: 'Integration playbooks that protect continuity and capture synergy value on an accelerated timeline.',
  },
  {
    title: 'Private Equity Performance',
    copy: 'Supply chain value creation roadmaps built to accelerate margin enhancement across portfolio companies.',
  },
]

export const competencies = [
  {
    title: 'AI and Digital Procurement Platforms',
    copy: 'End to end Source to Pay transformation, platform implementation, and automation of sourcing and buying workflow.',
    points: ['Digital platform implementation', 'Process automation', 'Spend visibility'],
  },
  {
    title: 'Strategic Sourcing and Category Strategy',
    copy: 'Category strategy development and sourcing execution across Information Technology, Cloud, Digital Marketing, Business Process Outsourcing, Legal, and Human Resources.',
    points: ['Global category leadership', 'Sourcing execution', 'Negotiation strategy'],
  },
  {
    title: 'Spend Optimization and Cost Management',
    copy: 'More than one billion dollars in spend under management with recurring cost reduction ranging from eight to thirty five percent.',
    points: ['$1B+ spend execution', 'Recurring savings delivery', 'Working capital improvement'],
  },
  {
    title: 'Enterprise Risk, Governance and ESG',
    copy: 'Contract controls, Securities and Exchange Commission compliance, supplier frameworks, and responsible spending programmes.',
    points: ['SEC and contract compliance', 'Supplier risk frameworks', 'ESG spend programmes'],
  },
  {
    title: 'Mergers, Private Equity and Integration',
    copy: 'Value creation roadmaps, acquisition integration leadership, and margin enhancement across portfolio supply chains.',
    points: ['Integration roadmaps', 'Value creation analysis', 'Margin enhancement'],
  },
  {
    title: 'Cross Functional Leadership',
    copy: 'Trusted advisor to executive committees, partnering across Finance, Legal, Risk, and business teams to align sourcing with enterprise priorities.',
    points: ['Executive committee advisory', 'Global team development', 'Stakeholder alignment'],
  },
]

export const timeline = [
  {
    company: 'Morgan Stanley',
    period: '2022 to Present',
    sector: 'Global Financial Services',
    roles: [
      {
        role: 'Head of Global Sourcing Transformation',
        span: 'October 2024 to Present',
        place: 'Minneapolis, MN',
        copy: 'Leads Source to Pay transformation across people, process, and technology, building scalable digital first procurement operations supported by AI enabled technologies and automation.',
      },
      {
        role: 'Head of Acquisition Integration and Private Equity Supply Chain Optimization',
        span: 'January 2022 to September 2024',
        place: 'Minneapolis, MN',
        copy: 'Led a team focused on acquisition integration and private equity supply chain performance, identifying value creation opportunities and developing roadmaps to accelerate margin enhancement.',
      },
    ],
  },
  {
    company: 'Eaton Vance',
    period: '2020 to 2022',
    sector: 'Asset Management',
    roles: [
      {
        role: 'Vice President, Head of Sourcing and Procurement',
        span: 'September 2020 to January 2022',
        place: 'Minneapolis, MN',
        copy: 'Led all global sourcing and procurement activity as a trusted advisor to the executive committee, implementing an end to end digital procurement platform and policy, and transforming procurement into a strategic and agile function focused on cost management, innovation, supplier excellence, and risk reduction.',
      },
    ],
  },
  {
    company: 'Radisson Hotel Group',
    period: '2018 to 2020',
    sector: 'Global Hospitality',
    roles: [
      {
        role: 'Senior Director, Strategic Sourcing and Supplier Management',
        span: 'May 2018 to September 2020',
        place: 'Global',
        copy: 'Led indirect global sourcing with strategy development and execution across the Americas, Asia Pacific, and Europe. Created a supplier framework that enabled a Software as a Service solution licensed to more than one thousand three hundred properties globally.',
      },
    ],
  },
  {
    company: 'Ameriprise Financial Services',
    period: '2015 to 2018',
    sector: 'Financial Advice and Wealth Management',
    roles: [
      {
        role: 'Director of Enterprise Procurement, Strategic Sourcing',
        span: 'March 2015 to May 2018',
        place: 'Minneapolis, MN',
        copy: 'Led strategy development across Information Technology, Labour, and Digital Marketing categories, exceeding savings targets in consecutive years while strengthening governance across all external partner relationships.',
      },
    ],
  },
  {
    company: 'General Mills',
    period: '1996 to 2015',
    sector: 'Global Consumer Packaged Goods',
    roles: [
      {
        role: 'Senior Sourcing Manager and Category Lead, Indirect',
        span: 'September 2014 to March 2015',
        place: 'Minneapolis, MN',
        copy: 'Category team lead across Business Process Outsourcing, Human Resources, Facilities, Real Estate, Legal, and Finance, creating a supplier management framework for outsourced business processes across the United States, Europe, and Asia.',
      },
      {
        role: 'Senior Sourcing Manager and Global Category Lead, Advertising, Insights, Digital and Media',
        span: 'October 2010 to September 2014',
        place: 'Minneapolis, MN',
        copy: 'More than one billion dollars of spend under management. Introduced procurement into the digital marketing function, implemented programmatic buying that reduced digital media costs by more than twenty percent, and re engineered the advertising supply chain for a thirty five percent cost reduction.',
      },
      {
        role: 'Senior Sourcing Manager and Global Category Lead, Information and Supply Chain Technologies',
        span: 'April 2003 to October 2010',
        place: 'Minneapolis, MN',
        copy: 'Sourced, negotiated, and managed global multi million dollar contracts across hardware, software, telecom, cloud, services, and supply chain technology, consistently delivering savings in excess of eight percent annually.',
      },
      {
        role: 'Manager, Sourcing and Vendor Management',
        span: 'November 2001 to April 2003',
        place: 'Minneapolis, MN',
        copy: 'Implemented a supplier relationship framework with key performance indicators, accountability, and performance tracking, and rolled out a strategic vendor licence management programme.',
      },
      {
        role: 'Manager, Corporate and Technology Sourcing',
        span: 'February 2000 to November 2001',
        place: 'Minneapolis, MN',
        copy: 'Led a team of forty across Human Resources, Finance, Facilities, Information Technology, and Legal categories, leveraging consortium synergies to deliver savings exceeding twenty five million dollars.',
      },
      {
        role: 'Analyst to Manager, Contract and Vendor Management',
        span: 'August 1996 to February 2000',
        place: 'Minneapolis, MN',
        copy: 'Established contract controls for data centre operations and built the contract and vendor management function, delivering six percent savings annually with two promotions in four years.',
      },
    ],
  },
]

export const earlyCareer = [
  {
    company: 'Hayes Chemicals',
    role: 'National Sales Account Manager',
    span: 'February 1994 to June 1995',
    place: 'Manchester, United Kingdom',
    copy: 'Top sales manager in 1995 with thirty eight percent year over year sales growth.',
  },
  {
    company: 'BASF',
    role: 'National Sales Coordinator and Logistics and Warehousing Intern',
    span: 'July 1989 to February 1994',
    place: 'Manchester, United Kingdom',
    copy: 'Selected for the management trainee programme and orchestrated sales activity across the United Kingdom for the Fine Chemicals division.',
  },
]

export const metrics = [
  { prefix: '$', value: 1, suffix: 'B+', label: 'Spend under direct global management' },
  { prefix: '', value: 35, suffix: '%', label: 'Cost reduction in advertising and digital media supply chain' },
  { prefix: '', value: 4, suffix: 'x', label: 'Speed to market improvement for digital assets' },
  { prefix: '$', value: 25, suffix: 'M+', label: 'Delivered through corporate consortium integration' },
  { prefix: '', value: 1300, suffix: '+', label: 'Global properties enabled through SaaS revenue frameworks' },
]

export const frameworkLayers = [
  {
    stage: 'Layer One',
    title: 'Intelligence and Insight',
    copy: 'AI driven spend analysis and category intelligence that surface savings opportunities and build an active pipeline for leadership review.',
    items: ['Spend visibility', 'Category intelligence', 'Opportunity pipeline'],
  },
  {
    stage: 'Layer Two',
    title: 'Sourcing and Execution',
    copy: 'Programmatic buying, competitive bid discipline, and standardised buying processes that convert strategy into contracted value.',
    items: ['Programmatic buying', 'Competitive bid', 'Standardised buying'],
  },
  {
    stage: 'Layer Three',
    title: 'Governance and Performance',
    copy: 'Automated supplier governance with service level agreements, key performance indicators, and vendor performance improvement programmes.',
    items: ['SLA and KPI tracking', 'Automated governance', 'Vendor improvement programmes'],
  },
]

export const vendorEcosystem = [
  'SAP',
  'Oracle',
  'IBM',
  'Microsoft',
  'Salesforce',
  'AT&T',
  'Rockwell',
  'HP',
]

export const credentials = [
  {
    kind: 'Education',
    title: 'Master Certificate, Commercial Contract Management',
    issuer: 'Villanova University',
    detail: '2010',
  },
  {
    kind: 'Education',
    title: "Bachelor's Degree, Business and Finance",
    issuer: 'Leeds Beckett University, United Kingdom',
    detail: '1986 to 1989',
  },
  {
    kind: 'Certification',
    title: 'Certified Associate in Project Management',
    issuer: 'Project Management Institute',
    detail: 'CAPM',
  },
  {
    kind: 'Certification',
    title: 'ITIL Practitioner, Measuring, Reporting and Improving Operations and Services',
    issuer: 'ITIL',
    detail: 'Practitioner level',
  },
  {
    kind: 'Certification',
    title: 'Foundation Certificate in IT Service Management',
    issuer: 'IT Service Management',
    detail: 'Foundation level',
  },
]

export const insights = [
  {
    category: 'Artificial Intelligence',
    title: 'The Future of AI in Source to Pay',
    copy: 'How intelligent automation moves procurement from transactional processing to continuous value creation across the full Source to Pay lifecycle.',
    readTime: '8 minute read',
  },
  {
    category: 'Private Equity',
    title: 'Optimizing Private Equity Supply Chains',
    copy: 'A practical roadmap for identifying value creation opportunities inside portfolio company supply chains and accelerating margin enhancement.',
    readTime: '6 minute read',
  },
  {
    category: 'Governance',
    title: 'Building ESG Frameworks in Enterprise Sourcing',
    copy: 'Embedding environmental, social, and governance criteria into supplier selection and performance management without slowing execution.',
    readTime: '7 minute read',
  },
]

export const topSkills = [
  'Strategic Sourcing',
  'Sourcing Category Strategy Development',
  'Business Process Improvement',
]
